// v5-socket.js  — ES5 kompatibilno

var ballColors = [
  "red", "green", "blue", "purple",
  "brown", "yellow", "orange", "black"
];

var BALL_DRAW_TIMEOUT = 1300;
var SOCKET_HOST = "https://display.elbet.com";

// helpers bez modernih metoda
function endsWithHost(host, suffix) {
  var hl = host.length, sl = suffix.length;
  if (sl > hl) return false;
  return host.slice(hl - sl) === suffix;
}

function getQuerySockPort() {
  try {
    var href = window.location.href;
    var m = href.match(/[?&]sock=(\d+)/);
    if (m) return m[1];
  } catch (e) {}
  return null;
}

// dinamika host -> port bez .find i arrow
function pickSocketBase() {
  // 1) query param override ?sock=PORT
  var qp = getQuerySockPort();
  if (qp) {
    console.log("[sock] override via ?sock=", qp);
    return SOCKET_HOST + ":" + qp;
  }

  // 2) global override window.SOCKET_PORT
  if (typeof window.SOCKET_PORT === "number") {
    console.log("[sock] override via window.SOCKET_PORT=", window.SOCKET_PORT);
    return SOCKET_HOST + ":" + window.SOCKET_PORT;
  }

  // 3) mapiranje po hostname-u
  var host = window.location.hostname; // bez porta
  var port = 4000; // default

  try {
    if (host === "online.elbetdev.com") {
      port = 4000;
    } else if (host === "online.zb.elbet.com" || endsWithHost(host, ".online.zb.elbet.com")) {
      port = 4104;
    } else if (host === "online.weldmag.elbet.com" || endsWithHost(host, ".online.weldmag.elbet.com")) {
      port = 4580;
    }
  } catch (e) {}

  console.log("[sock] hostname=", host, " -> port=", port);
  return SOCKET_HOST + ":" + port;
}

function WebSock() {
  this.ballTimeout = null;

  var base = pickSocketBase();
  // eslint-disable-next-line no-undef
  this.socket = io.connect(base, {
    secure: true,
    resource: "socket.io",
    transports: ["websocket", "xhr-polling"]
  });

  var self = this;

  this.socket.on("connect", function() {
    console.log("[✓] Top level sock connected.", base);
    self.socket.removeAllListeners();
    self.subscribe();
  });

  this.socket.on("disconnect", function(e) {
    if (self.ballTimeout) clearTimeout(self.ballTimeout);
    console.log("[x] Disconnected.", e);
  });

  this.socket.on("error", function(err) {
    console.error("[!] Socket.IO error:", err);
  });
}

WebSock.prototype.subscribe = function() {
  var self = this;
  var bus = window; // isti kontekst

  this.socket.emit("subscribe", { room: "ball" });

  // --- slušanje novih kuglica ---
  this.socket.on("ball", function(data) {
    var color = ballColors[(data.ball - 1) % ballColors.length];
    var BALL = { index: data.id, number: data.ball, color: color };

    console.log("NEW BALL NOW PUT INTRO IN DRUMS ", BALL);
    self.ballTimeout = setTimeout(function() {
      bus.dispatchEvent(new CustomEvent("lb_ball", { detail: BALL }));
    }, BALL_DRAW_TIMEOUT);

    console.log("[←] ball:", data);
  });

  // --- slušanje početka nove runde ---
  this.socket.on("new", function(data) {
    window.todayRoundId = data.roundid_today;
    if (data.roundid_today) {
      window.currentDrawRoundToday = String(data.roundid_today);
      window.drawnNumbersForRound = String(data.roundid_today);
    }
    console.log("[←] new_round event:", data);
    bus.dispatchEvent(new CustomEvent("lb_new_round", { detail: data || {} }));
  });

  this.socket.on("state", function(data) {
    var balls = (data && data.balls) ? data.balls : [];
    // gurni “kakvo-je-stanje” u app kao lb_state
    window.todayRoundId = data.roundid_today;
    if (data.roundid_today) {
      window.currentDrawRoundToday = String(data.roundid_today);
      window.drawnNumbersForRound = String(data.roundid_today);
    }
    window.dispatchEvent(new CustomEvent("lb_state", { detail: { balls: balls } }));
    console.log("[←] state:", balls);
  });
};

export default WebSock;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/v5-socket.js
// module id = 1216
// module chunks = 0